export const LOCAL_AGREEMENTS = '/local_agreements';